var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVehicleArrowReturn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.94 10.95L18.69 5.7C18.57 5.42 18.3 5.25 18 5.25H15.75V3.75C15.75 3.34 15.41 3 15 3H5.33L7.27 1.06L6.21 0L2.46 3.75L6.21 7.5L7.27 6.44L5.33 4.5H14.25V13.92C13.56 14.32 13.06 14.98 12.86 15.75H8.15C7.74 14.15 6.12 13.19 4.52 13.59C3.46 13.86 2.63 14.69 2.36 15.75H1.5V9H0V16.5C0 16.91 0.34 17.25 0.75 17.25H2.36C2.77 18.85 4.39 19.81 5.99 19.41C7.05 19.14 7.88 18.31 8.15 17.25H12.86C13.27 18.85 14.89 19.81 16.49 19.41C17.55 19.14 18.38 18.31 18.65 17.25H20.26C20.67 17.25 21.01 16.91 21.01 16.5V11.25C21.01 11.15 20.99 11.05 20.95 10.95H20.94ZM5.25 18C4.42 18 3.75 17.33 3.75 16.5C3.75 15.67 4.42 15 5.25 15C6.08 15 6.75 15.67 6.75 16.5C6.75 17.33 6.08 18 5.25 18ZM15.75 6.75H17.51L19.12 10.5H15.76V6.75H15.75ZM15.75 18C14.92 18 14.25 17.33 14.25 16.5C14.25 15.67 14.92 15 15.75 15C16.58 15 17.25 15.67 17.25 16.5C17.25 17.33 16.58 18 15.75 18ZM19.5 15.75H18.64C18.3 14.43 17.11 13.5 15.75 13.5V12H19.5V15.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVehicleArrowReturn);
export default __webpack_public_path__ + "static/media/ic-vehicle-arrow-return.40e0c32e42e64dda52f0d24fb91d25e5.svg";
export { ForwardRef as ReactComponent };